module.exports = __webpack_public_path__ + "img/Home_Mobile_06.60d6a6bd.jpg";